interface KPICardProps {
  label: string
  value: string | number | null
  sub?: string | null
}

export default function KPICard({ label, value, sub }: KPICardProps) {
  return (
    <div className="kpi-card">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value ?? '–'}</div>
      {sub && <div className="kpi-sub">{sub}</div>}
    </div>
  )
}
